<script>
export default {
	props: {
		content: {
			type: Object,
		},
	},
	data() {
		return {
			thead: null,
			tbody: null,
			accordion: null,
		};
	},
	computed: {
		hasTopHeader() {
			return this.content.value.useFirstRowAsHeader;
		},
		hasSideHeader() {
			return this.content.value.useFirstColumnAsSideHeader;
		},
	},
	methods: {
		populateAccordion(base) {
			const tmp = [];
			let _index = null;

			base.cells.forEach((row, rowIndex) => {
				row.forEach((cell, cellIndex) => {
					if (rowIndex === 0
						&& ((this.hasSideHeader && cellIndex > 0)
						|| !this.hasSideHeader)) {
						tmp.push({
							topheader: cell.value,
							items: [],
						});
					} else if (rowIndex > 0) {
						_index = this.hasSideHeader && cellIndex > 0
							? cellIndex - 1
							: cellIndex;

						tmp[_index].items.push({
							sideheader: this.hasSideHeader
								? row[0].value
								: '',
							content: cell.value,
							setting: cell.setting,
						});
					}
				});
			});
			this.$set(this, 'accordion', tmp);
		},
		setupSections(tableSetup) {
			if (this.hasTopHeader) {
				this.populateAccordion(tableSetup);
				this.thead = tableSetup.cells.splice(0, 1);
			}

			this.tbody = tableSetup.cells;
		},
		convertLineBreaks(string) {
			return string && string.indexOf('\n') !== -1
				? string.split('\n').join('<br />')
				: string;
		},
		styleObject(value) {
			return value
				? { backgroundColor: value }
				: null;
		},
	},
	created() {
		this.setupSections(this.content.value);
	},
};
</script>

<template src="./sky-scheme.html"></template>
<style src="./sky-scheme.scss"></style>


// WEBPACK FOOTER //
// sky-scheme.vue?aed5c40a